<template>
  <div class="authorities">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/behorden">Behörden</router-link>
    </Breadcrumb>
    <div class="wrapper margin-bottom--60 margin-top--40">
      <div class="headline-link">
        <Headline subline="Bürgerservice" headline="Ämter & Behörden in Augsburg" />
        <div class="list-layout">
          <Icon icon="list"/>
          <Icon icon="grid" class="list-layout--active"/>
        </div>
      </div>
      <SearchFilter :action="filterList" v-model="searchTerm" placeholder="Nach Behörden & Ämtern suchen..."></SearchFilter>
      <Alphabet class="margin-top--20"/>
      <p v-if="allAuthorities.length < 1" class="no-results">
        <span>Keine Ergebnisse</span>
        Leider konnten keine passenden Behörden oder Ämter zu Ihrer Anfrage gefunden werden. 
        <br>Eventuell werden Sie direkt bei unseren <router-link to="/services">Dienstleistungen</router-link> fündig.
      </p>
      <paginate v-else
            ref="paginator"
            name="allAuthorities"
            :list="allAuthorities"
            :per="12"
            class="margin-top--40"
          >
        <transition-group name="list" class="row">
          <div v-for="authority in paginated('allAuthorities')" :key="authority.id" class="list-item col-xs-12 col-sm-6 col-md-3">
            <AuthorityCard :authority="authority"/>
          </div>
        </transition-group>
      </paginate>
      <div v-if="allAuthorities.length > 0" class="paginate-bottom margin-top--30">
        <span v-if="$refs.paginator">
        {{$refs.paginator.pageItemsCount}} Ergebnisse
        </span>
        <paginate-links v-if="allAuthorities.length > 12" for="allServices" :limit="3" :step-links="{ next: '>', prev: '<' }"></paginate-links>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import SearchFilter from '../../components/SearchFilter/SearchFilter';
import AuthorityCard from '../../components/AuthorityCard/AuthorityCard';
import Alphabet from '../../components/Alphabet/Alphabet';

export default {
  name: 'Authorities',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    SearchFilter,
    AuthorityCard,
    Alphabet,
  },
  data() {
    return {
      searchTerm: '',
      allAuthorities: null,
      paginate: [ 'allAuthorities' ],
    };
  },
  computed: {
    ...mapGetters({
      getAllAuthorities: 'authorities/getAllAuthorities',
      getAuthoritiesByName: 'authorities/getAuthoritiesByName',
    }),
  },
  methods: {
    filterList() {
      this.allAuthorities = this.getAuthoritiesByName(this.searchTerm);
    },
  },
  created() {
    this.allAuthorities = this.getAllAuthorities;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Authorities.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Authorities/Authorities.vue